import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { CFCProps, AppAlert } from 'types';
import { RootState } from 'redux/root.reducer';
import {
  InlineNotification,
  NotificationActionButton
} from 'carbon-components-react';
import { removeAlert } from 'redux/alerts/actions';

const InlineToastAlerts: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { alertsCache } = props;
  const { data } = alertsCache;
  let inlineNotification: any = null;
  let toastNotification: AppAlert[] = [];
  data.forEach((item: any) =>
    item.type === 'inline'
      ? (inlineNotification = item) // only one inline is supported.
      : (toastNotification = [...toastNotification, item])
  );
  return (
    <>
      {inlineNotification && (
        <InlineNotification
          className="inline-toast-container"
          key={inlineNotification.id}
          kind={inlineNotification.kind}
          title={inlineNotification.notificationProps.title}
          subtitle={inlineNotification.notificationProps.subtitle}
          lowContrast={inlineNotification.notificationProps.lowContrast}
          hideCloseButton={inlineNotification.notificationProps.hideCloseButton}
          actions={
            inlineNotification.notificationProps.doActions && (
              <NotificationActionButton
                onClick={inlineNotification.notificationProps.doActions}
              >
                {inlineNotification.notificationProps.actionButtonText ||
                  'Remove'}
              </NotificationActionButton>
            )
          }
          onCloseButtonClick={() =>
            dispatch(removeAlert(inlineNotification.id))
          }
        />
      )}
    </>
  );
};

const mapStateToProps = ({ alertsCache }: RootState) => ({
  alertsCache
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;

InlineToastAlerts.displayName = 'InlineToastAlerts';

export default connector(InlineToastAlerts);
